import { Controller } from '@hotwired/stimulus';
import { application } from 'src/app';
import { find, getCSSProperty } from '@fretadao/f-js-dom';

application.register(
  'sticky-element',
  class extends Controller {
    static values = {
      'top': Number
    };

    connect() {
      this.stickyScroll();

      document.addEventListener('scroll', () => this.stickyScroll());
    }

    disconnect() {
      document.removeEventListener('scroll', () => this.stickyScroll());
    }

    stickyScroll() {
      const elementHeight = parseInt(getCSSProperty(this.element, 'height'));

      const containerClass = this.element.parentNode;
      const containerBounds = containerClass.getBoundingClientRect();

      const scrollTop = window.scrollY;
      const containerTop = containerBounds.top + scrollTop;
      const containerBottom = containerBounds.bottom + scrollTop;

      const scrollBottom = scrollTop + elementHeight + this.topValue;

      if (scrollTop + this.topValue < containerTop) {
        this.element.style.top = containerTop - scrollTop + 'px';
      } else if (scrollBottom + this.topValue > containerBottom) {
        const difference = scrollBottom - containerBottom;
        this.element.style.top = 0 - difference + this.topValue + 'px';
      } else {
        this.element.style.top = this.topValue + 'px';
      }
    }
  }
);
